import React, { useState, useEffect } from "react";
import './PontoCard.css';
import img1 from './../../../../public/Images/1.png';
import img2 from './../../../../public/Images/2.png';
import img3 from './../../../../public/Images/3.png';
import img4 from './../../../../public/Images/4.png';
import img5 from './../../../../public/Images/5.png';
import { api } from '../../../services/api';
import { Modal, Button } from 'react-bootstrap';

const sentimentos = [
    { id: 1, png: img1 },
    { id: 2, png: img2 },
    { id: 3, png: img3 },
    { id: 4, png: img4 },
    { id: 5, png: img5 }
];

const PontoCard = ({ registro, onUpdate, onExpandFoto }) => {
    const [foto, setFoto] = useState(null);
    const [justificativa, setJustificativa] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [justificativaNegacao, setJustificativaNegacao] = useState("");
    const [motivosFalta, setMotivosFalta] = useState([]);
    const [motivoSelecionado, setMotivoSelecionado] = useState("");
    const fotoCache = new Map();
    const [chapa, setChapa] = useState('');

    function capitalizeName(name) {
        if (!name) return '';
        return name
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    useEffect(() => {
        const chapaStorage = localStorage.getItem("chapa");
        if (chapaStorage) setChapa(chapaStorage);
    }, []);

    // 🔹 Carregar foto
    useEffect(() => {
        const hoje = new Date().toISOString().slice(0, 10);
        const chave = `${registro.matricula}_${hoje}`;

        if (fotoCache.has(chave)) {
            setFoto(fotoCache.get(chave));
        } else {
            api.get(`/usuario/foto/${registro.matricula}`)
                .then(res => {
                    fotoCache.set(chave, res.data.foto);
                    setFoto(res.data.foto);
                })
                .catch(() => console.log("Erro ao buscar foto"));
        }
    }, [registro.matricula]);

    // 🔹 Carregar motivos de falta
    useEffect(() => {
        if (registro.falta !== "0:00") {
            api.get(`/ponto/justificativa`)
                .then(res => setMotivosFalta(res.data))
                .catch(() => console.log("Erro ao buscar motivos de falta"));
        }
    }, [registro.falta]);

    const handleSubmitFalta = () => {
        if (!motivoSelecionado) {
            alert("Selecione um motivo da falta.");
            return;
        }

        api.post(`/ponto/${registro.matricula}/ocorrencia`, {
            chapa,
            data: registro.dataponto,
            justificativa: motivoSelecionado,
            aprovado: 'S'
        })
            .then((response) => {
                if (response.status === 201) {
                    onUpdate(registro.matricula, registro.data);
                } else {
                    alert("Erro ao registrar justificativa da falta.");
                }
            })
            .catch(() => {
                alert("Erro ao conectar com o servidor.");
            });
    };

    const handleAutorizado = () => {
        const texto = justificativa.trim().length >= 10 ? justificativa.trim() : 'Atraso Aprovado';
        api.post(`/ponto/${registro.matricula}/ocorrencia`, {
            chapa,
            data: registro.dataponto,
            justificativa: texto,
            aprovado: 'S'
        })
            .then((response) => {
                if (response.status === 201) {
                    onUpdate(registro.matricula, registro.data);
                } else {
                    alert("Erro ao registrar aprovação.");
                }
            })
            .catch(() => {
                alert("Erro ao conectar com o servidor.");
            });
    };

    return (
        <div className="card card-ponto shadow-sm text-center position-relative">
            <div className="sentimento-icon">
                {registro.sentimento && (
                    <img src={sentimentos[registro.sentimento - 1].png} alt="sentimento" />
                )}
            </div>

            <div className="card-body">
                <div><strong>{registro.dia} - {registro.data}</strong></div>

                <img
                    src={foto ? `data:image/jpeg;base64,${foto}` : "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"}
                    alt="foto"
                    className="rounded-circle mb-2 mx-auto d-block"
                    style={{ width: 150, height: 150, objectFit: 'cover', cursor: 'pointer' }}
                    onClick={() => {
                        if (foto && onExpandFoto) {
                            onExpandFoto(`data:image/jpeg;base64,${foto}`, capitalizeName(registro.nome) ,capitalizeName(registro.funcao));
                        }
                    }}
                />

                <h5 className="mb-0">{capitalizeName(registro.nome)}</h5>
                <small className="text-muted">{registro.matricula} | {capitalizeName(registro.funcao)}</small>
                <div className="mt-2"><b>{registro.marcacoes}</b></div>

                <div style={{ fontSize: '0.9rem' }}>
                    {/* 🔹 Caso FALTA */}
                    {registro.falta !== "0:00" && (
                        <>
                            <div className="mb-1 mt-2 text-danger"><strong>FALTA</strong></div>
                            <label className="text-muted">Selecione o motivo:</label>
                            <select
                                className="form-select mb-2"
                                value={motivoSelecionado}
                                onChange={e => setMotivoSelecionado(e.target.value)}
                            >
                                <option value="">-- Selecione --</option>
                                {motivosFalta.map((motivo, idx) => (
                                    <option key={idx} value={motivo}>{motivo}</option>
                                ))}
                            </select>
                            <button
                                className="btn btn-primary btn-sm w-100"
                                onClick={handleSubmitFalta}
                                disabled={!motivoSelecionado}
                            >
                                Enviar Justificativa
                            </button>
                        </>
                    )}

                    {/* 🔹 Caso ATRASO */}
                    {registro.atraso !== "0:00" && (
                        <>
                            <div className="mb-1 mt-2 text-warning">Atraso de {registro.atraso}</div>
                            <div className="d-flex justify-content-center gap-2">
                                <button
                                    className="btn btn-success btn-sm"
                                    style={{ flex: 1 }}
                                    onClick={handleAutorizado}
                                >
                                    Autorizado
                                </button>

                                <button
                                    className="btn btn-danger btn-sm"
                                    style={{ flex: 1 }}
                                    onClick={() => setShowModal(true)}
                                >
                                    Negado
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* 🔹 Modal de Negação (somente atraso) */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Justificativa para Negar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Descreva a justificativa (mínimo 10 caracteres)"
                        value={justificativaNegacao}
                        onChange={(e) => setJustificativaNegacao(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="danger"
                        disabled={justificativaNegacao.trim().length < 10}
                        onClick={() => {
                            const textoNegacao = justificativaNegacao.trim();
                            setShowModal(false);
                            setJustificativaNegacao("");

                            api.post(`/ponto/${registro.matricula}/ocorrencia`, {
                                chapa,
                                data: registro.dataponto,
                                justificativa: textoNegacao,
                                aprovado: 'N'
                            }).then((response) => {
                                if (response.status === 201) {
                                    onUpdate(registro.matricula, registro.data);
                                } else {
                                    alert("Erro ao registrar justificativa.");
                                }
                            }).catch(() => {
                                alert("Erro ao conectar com o servidor.");
                            });
                        }}
                    >
                        Confirmar Negação
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PontoCard;
